import { CURRENCIES, UNIT_CODES } from "@bt/parts-core";
import { z } from "zod";

/** Validation messages are i18n keys ("validation.*") that the web app translates. */

export const id = z.string().min(1);
export const nullableId = id.nullish().transform((v) => v ?? null);

export const requiredText = z
  .string()
  .trim()
  .min(1, { error: "validation.required" })
  .max(500, { error: "validation.tooLong" });

export const optionalText = z
  .string()
  .trim()
  .max(500, { error: "validation.tooLong" })
  .nullish()
  .transform((v) => (v ? v : null));

export const longText = z
  .string()
  .max(50_000, { error: "validation.tooLong" })
  .nullish()
  .transform((v) => (v?.trim() ? v : null));

/** Quantities in milli-units (architecture.md › Quantities and money). */
export const qty = z.int({ error: "validation.number" });
export const positiveQty = z
  .int({ error: "validation.number" })
  .positive({ error: "validation.positive" });
export const nonNegativeQty = z
  .int({ error: "validation.number" })
  .nonnegative({ error: "validation.nonNegative" });

/**
 * Money in minor units (architecture.md › Quantities and money), on the garage's price basis.
 * Stored without tax at 100 times that (ADR 0009), it has to fit a Postgres integer.
 */
export const moneyMinor = z
  .int({ error: "validation.number" })
  .nonnegative({ error: "validation.nonNegative" })
  .max(21_474_836, { error: "validation.tooLarge" });
export const nullableMoneyMinor = moneyMinor.nullish().transform((v) => v ?? null);

export const currency = z.enum(CURRENCIES);
export const unit = z.enum(UNIT_CODES);

/** Calendar date "YYYY-MM-DD". */
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, { error: "validation.date" });
export const optionalIsoDate = isoDate.nullish().transform((v) => v ?? null);

/** Year and month "YYYY-MM". */
export const yearMonth = z
  .string()
  .regex(/^\d{4}-(0[1-9]|1[0-2])$/, { error: "validation.date" })
  .nullish()
  .transform((v) => v ?? null);

export const webUrl = z.url({ protocol: /^https?$/, error: "validation.url" });

export const optionalEmail = z
  .union([z.email({ error: "validation.email" }), z.literal("")])
  .nullish()
  .transform((v) => (v ? v : null));

export const optionalUrl = z
  .union([webUrl, z.literal("")])
  .nullish()
  .transform((v) => (v ? v : null));
